const featureToggles = {
  FEATURE_TOGGLE_ADMIN: "admin_feature_toggles",
  LOOKING_GLASS: "looking_glass",
  DIFFUSION_TRACTOGRAPHY: "diffusion_tractography",
  MIZAR: "mizar",
  PLY_UPLOAD: "ply_upload",
  WEBSITE_PREVIEW: "website_preview",
  AUDIT_READER: "audit_reader",
  ADMIN_GROUP_ICONS: "admin_group_icons",
};

export default featureToggles;
